import type { ReactNode } from 'react';

export interface FaqItem {
  key: string;
  question: ReactNode;
  answer?: ReactNode;
}

export interface FaqProps {
  title?: string;
  items: readonly FaqItem[];
}

/** 原生折叠问答；数据清洗、富文本解析和区块背景由调用方负责。 */
export default function Faq({ title, items }: FaqProps) {
  if (items.length === 0) return null;

  return (
    <div>
      {title && (
        <p className="mb-[19px] text-center font-bb text-[20px] leading-[24px] min-[920px]:mb-[32px] min-[920px]:text-[24px] min-[920px]:leading-[28px]">
          {title}
        </p>
      )}
      <div>
        {items.map((item) => (
          <details key={item.key} className="group border-b border-[#d1d9e0] first:border-t">
            <summary className="flex cursor-pointer list-none items-start justify-between gap-[16px] py-[16px] font-bb text-[14px] leading-[17px] marker:content-none group-open:pb-[12px] min-[920px]:items-center min-[920px]:py-[24px] min-[920px]:text-[16px] min-[920px]:leading-[19px] min-[920px]:group-open:pb-[16px] [&::-webkit-details-marker]:hidden">
              <h2 className="min-w-0 flex-1 break-words">{item.question}</h2>
              {/* 保留原 SVG 和原生 img，避免提取时改变资源请求及输出结构。 */}
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src="/zeelool-next/goods-list/seo-footer/faq-chevron.svg"
                alt=""
                width={16}
                height={16}
                className="size-[16px] shrink-0 transition-transform duration-200 motion-reduce:transition-none group-open:rotate-180"
              />
            </summary>
            {item.answer && (
              <div className="w-full break-words whitespace-pre-line pb-[16px] font-ir text-[12px] leading-[18px] min-[920px]:pb-[24px]">
                {item.answer}
              </div>
            )}
          </details>
        ))}
      </div>
    </div>
  );
}
